import React from 'react';
import { Upload, RotateCcw } from 'lucide-react';

export function AdminSutaBasesCard({
  STATES,
  DEFAULT_SUTA_BASES,
  customSutaBases,
  setCustomSutaBases,
  sutaBases,
  sutaUploadInfo,
  sutaFileRef,
  handleSutaUpload,
  adminApi,
}) {
  const handleReset = async () => {
    setCustomSutaBases(null);
    try {
      await adminApi.resetOverride("suta_bases");
    } catch (error) {
      console.error('Failed to reset SUTA bases:', error.message);
    }
  };

  return (
    <div className="bg-white border border-slate-200 rounded-xl shadow-sm" data-testid="suta-bases-card">
      <div className="p-5 border-b border-slate-100 flex items-center justify-between">
        <h2 className="text-base font-semibold font-['Outfit'] text-slate-900">SUTA Wage Bases by State</h2>
        <div className="flex items-center gap-2">
          {sutaUploadInfo && (
            <span className="text-xs text-emerald-600 font-medium" data-testid="suta-upload-info">
              {sutaUploadInfo}
            </span>
          )}
          <input
            ref={sutaFileRef}
            type="file"
            accept=".csv,.xlsx,.xls"
            onChange={handleSutaUpload}
            className="hidden"
          />
          <button
            data-testid="upload-suta-bases-btn"
            onClick={() => sutaFileRef.current?.click()}
            className="flex items-center gap-1.5 px-3 py-1.5 bg-[#3c68ff] text-white rounded-lg text-xs font-medium hover:bg-[#2b4bca] transition-all"
          >
            <Upload size={13} /> Upload CSV/Excel
          </button>
          {customSutaBases && (
            <button
              data-testid="reset-suta-bases-btn"
              onClick={handleReset}
              className="flex items-center gap-1.5 px-3 py-1.5 bg-white border border-slate-200 text-slate-600 rounded-lg text-xs font-medium hover:bg-slate-50 transition-all"
            >
              <RotateCcw size={13} /> Reset
            </button>
          )}
        </div>
      </div>
      <div className="p-5">
        <div className="grid grid-cols-5 md:grid-cols-10 gap-2">
          {STATES.map(st => {
            const isCustom = customSutaBases && customSutaBases[st] !== DEFAULT_SUTA_BASES[st];
            return (
              <div key={st} className="text-center">
                <div className="text-xs font-semibold text-slate-700">{st}</div>
                <div className={`text-xs font-mono ${isCustom ? "text-emerald-600 font-semibold" : "text-slate-500"}`}>
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  }).format(sutaBases[st] || 0)}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
